<template>
    <div>
        <section class="padding-vertical-content white-content right-background" v-if="!mostrarResultado">
            <div class="container d-flex justify-content-center">
                <div class="row">
                    <div class="col-12">
                        <h2 class="m-0 mt-5 h1 text-uppercase">{{ $t('eventos.titulo_buscar_abono') }}</h2>
                        <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('eventos.subtitulo_buscar_abono') }}</div>
                    </div>

                    <div class="col-12">
                        <ContentOrLoading>
                            <div class="row" v-if="! loading">
                                <div class="col-12">
                                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                                        <div class="form-group">
                                            <label for="numero_abonado">{{ $t('eventos.numero_abono') }}</label>
                                            <ValidationProvider name="Número de Abonado" rules="required" v-slot="{ errors }">
                                                <input 
                                                    type="text"
                                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                    :placeholder="$t('eventos.numero_abono')"  v-model="numero_abonado" 
                                                />
                                                <div class="invalid-feedback" v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </div>
                                            </ValidationProvider>
                                        </div>

                                        <div class="form-group">
                                            <label for="dni">DNI/NIE</label>
                                            <ValidationProvider name="DNI" rules="required" v-slot="{ errors }">
                                                <input 
                                                    type="text"
                                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                    placeholder="DNI/NIE" v-model="dni" 
                                                />
                                                <div class="invalid-feedback" v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </div>
                                            </ValidationProvider>
                                        </div>

                                        <div class="form-group">
                                            <label for="PIN">PIN</label>
                                            <ValidationProvider name="PIN" rules="required" v-slot="{ errors }">
                                                <input 
                                                    type="text"
                                                    :class="'form-control ' + (errors[0] ? 'is-invalid' : '')"
                                                    placeholder="PIN" v-model="pin" 
                                                />
                                                <div class="invalid-feedback" v-if="errors[0]">
                                                    {{ errors[0] }}
                                                </div>
                                            </ValidationProvider>
                                        </div>

                                        <button type="submit" class="button large-button effect-button">
                                            <span>{{ $t('header.buscar')}}</span>
                                        </button>
                                    </ValidationObserver>
                                </div>
                            </div>
                        </ContentOrLoading>
                    </div>
                </div>
            </div>
        </section>

        <section class="padding-vertical-content white-content mb-3 mb-lg-4" v-if="error && !mostrarResultado">
            <div class="container d-flex justify-content-center">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-danger" role="alert">
                                    <h4>{{ $t('eventos.error_busqueda') }}</h4>
                                    <p>{{ error }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content white-content mb-3 mb-lg-4" v-if="mostrarResultado">
                <div class="container d-flex justify-content-center">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">¡{{ $t('eventos.encontrado') }}!</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('eventos.descripcion_encontrado')}}</div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="mb-4">
                                        <h3>{{ $t('eventos.datos') }}</h3>
                                        <table class="table table-bordered mb-4 mb-lg-5">
                                            <tr class="lightgray-content">
                                                <th></th>
                                                <th>{{ $t('partidos.info')}}</th>
                                            </tr>
                                            <tr>
                                                <td><strong>{{ $t('recordatorios.nombre')}}</strong></td>
                                                <td>{{ abonado_encontrado.name }} {{ abonado_encontrado.lastName }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>{{ $t('recordatorios.correo')}}</strong></td>
                                                <td>{{ abonado_encontrado.email }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>DNI/NIE</strong></td>
                                                <td>{{ abonado_encontrado.identification?.value }}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>{{ $t('formularios.domicilio')}}</strong></td>
                                                <td>
                                                    {{ abonado_encontrado.address?.streetLine1 }}, 
                                                    {{ abonado_encontrado.address?.city }}, 
                                                    {{ abonado_encontrado.address?.zipCode }}, 
                                                    {{ abonado_encontrado.address?.country }}
                                                </td>
                                            </tr>
                                            <tr v-if="abonado_encontrado.numero">
                                                <td><strong>Número de {{ teatro.texto_abono }}</strong></td>
                                                <td>{{ abonado_encontrado.numero }}</td>
                                            </tr>
                                        </table>

                                        <div class="alert alert-info">
                                            <p 
                                                v-html="$t('eventos.abono_vinculado', { 
                                                    abono: teatro.texto_abono, 
                                                    email: abonado_encontrado.email 
                                                })"
                                            >
                                            </p>
                                            <p v-html="$t('eventos.acceder_cuenta')"></p>
                                            <p 
                                                v-html="$t('eventos.problema_contacto', { 
                                                    email:'info@compralaentrada.com' 
                                                })"
                                            >
                                            </p>
                                        </div>

                                        <button @click="volverAlFormulario" class="button large-button effect-button">
                                            <i class="fas fa-arrow-left mr-2"></i>
                                            <span>{{ $t('carrito.volver')}}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';

    export default {        
        name: 'FormBuscarAbonado',
        data() {
            return {
                numero_abonado: '',
                dni: '',
                pin: '',
                loading: false,
                error: false,
                abonado_encontrado: null,
                mostrarResultado: false
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(!isValid) return;

                this.abonado_encontrado = null;
                this.loading = true;
                this.error = null;

                try{
                    const params = {
                        subscriber_number: this.numero_abonado,
                        beneficiary_id_doc: this.dni,
                        pin: this.pin
                    }

                    const response = await this.$store.dispatch(this.config.getVuexAlias('sga.buscar.abono'), { filters:params } );

                    if(response && response.data){
                        this.abonado_encontrado = response.data.data;
                        this.mostrarResultado = true;
                        this.$toast.success('Abonado encontrado');
                    } else{
                        this.error = 'No se encontró ningún abonado con esos datos.';
                        this.mostrarResultado = false;
                    }
                }
                catch(error){
                    this.$toast.error('Error al buscar abonado: ' + error);
                    this.mostrarResultado = false;
                }
                finally{
                    this.loading = false;
                }
            },

            volverAlFormulario() {
                this.mostrarResultado = false;
                this.abonado_encontrado = null;
                this.error = null;
            }


        },
        components: {
            ContentOrLoading
        }
    }
</script>
